'use client';
import { Box, FormControl, MenuItem, Select, Switch, Typography } from '@mui/material';

import { useT } from '@/hooks';

import { EXPIRATION_OPTIONS } from '@/constants/market.constants';

interface MobileExpirationSelectorProps {
  setExpiration: boolean;
  onExpirationToggle: (checked: boolean) => void;
  expirationValue: string;
  onExpirationValueChange: (value: string) => void;
}

export function MobileExpirationSelector({
  setExpiration,
  onExpirationToggle,
  expirationValue,
  onExpirationValueChange,
}: MobileExpirationSelectorProps) {
  const { t } = useT();
  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: setExpiration ? 1.5 : 0,
        }}
      >
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
          {t('trade.setExpiration')}
        </Typography>
        <Switch
          checked={setExpiration}
          onChange={(e) => onExpirationToggle(e.target.checked)}
          size="small"
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#2563eb',
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              bgcolor: '#2563eb',
            },
          }}
        />
      </Box>
      {/* Expiration Dropdown */}
      {setExpiration && (
        <FormControl fullWidth size="small" sx={{ mt: 1.5 }}>
          <Select
            value={expirationValue}
            onChange={(e) => onExpirationValueChange(e.target.value)}
            sx={{
              fontSize: '0.875rem',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'divider',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'primary.main',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'primary.main',
              },
            }}
            MenuProps={{
              sx: { zIndex: 30000 },
            }}
          >
            {EXPIRATION_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.value === 'end-of-day'
                  ? t('trade.endOfDay', { defaultValue: 'End of Day' })
                  : opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
}
